
export const APP_NAME = 'Shopitnow Admin';
export const THEME = 'dark';


export const APP_LOGO = '/icons/logo.png';
export const LOGIN_POSTER = '/images/broken-image.png';
export const BROKEN_IMAGE = '/images/login_poster.jpeg';
export const DASHBOARD_ICON = '/icons/dashboard_icon.png';


// export const API_HOST = 'http://localhost:8000';
export const API_HOST = 'https://api.shopitnow.ml';
export const PY_API_HOST = 'https://pyapi.shopitnow.ml'

export const BASIC_AUTH = 'Basic bWVldC5hcHBzY3JpcEBnbWFpbC5jb206M0VtYmVkMDA3'

export const DRAWER_CLOSE = "";
export const DRAWER_TOASTER_TIME = 3000;